import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../contexts/AppContext';
import tenantApi from '../../utils/api/tenant';
import { toast } from 'react-toastify';
import ToggleSmall from '../Shared/Toggle/ToggleSmall';

const Security = () => {
  const [collapse, setCollapse] = useState(true);
  const [mfaEnabled, setMfaEnabled] = useState<boolean>(false);
  const [busy, setBusy] = useState<boolean>(false);
  const appStore = useContext(AppContext);
  const user = appStore.get('user');

  const loadInitialData = () => {
    setBusy(true);
    tenantApi.mfa
      .getMfaEnabled(user.tenantId)
      .then((res) => {
        if (res) {
          setMfaEnabled(res.mfa_enabled || false);
        }
        setBusy(false);
      })
      .catch((e) => {
        console.error('Error loading MFA feature:', e);
        toast.error('Failed to load security settings');
        setBusy(false);
      });
  };

  useEffect(() => {
    if (user && user.tenantId) {
      loadInitialData();
    }
  }, [user?.tenantId]);

  const handleMFAToggle = async () => {
    setBusy(true);

    try {
      await tenantApi.mfa.editMfaEnabled(user.tenantId, { mfa_enabled: !mfaEnabled });
    
      setMfaEnabled(!mfaEnabled);
      toast.success(
        `Multi-Factor Authentication ${!mfaEnabled ? 'enabled' : 'disabled'} successfully!`
      );
    } catch (error) {
      console.error('Error updating MFA setting:', error);
      toast.error('Failed to update Multi-Factor Authentication setting');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className='settings-tenant-main-container'>
      <div
        className='settings-main-tenant-text'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setCollapse(!collapse)}
      >
        <h3>Security</h3>
        <i
          className={collapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'}
          aria-hidden='true'
        />
      </div>
      <hr />
      <div
        className={
          collapse ? 'administration-hidden' : 'administration-visible'
        }
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ marginTop: '0',marginLeft:'8px' }}>Enable Multi-Factor Authentication (MFA) Requirement</h3>
          <ToggleSmall
            isChecked={mfaEnabled}
            disabled={busy}
            handleChange={handleMFAToggle}
          />
        </div>
      </div>
      <br /><br /><br />
    </div>
  );
};

export default Security;
